import { useNavigate, useParams } from 'react-router-dom';

import { EventProvider } from '@/contexts';
import { UploadContentLayout } from '@/layout';
import { LiveStream } from '@/pages/Event/LiveStream/LiveStream';

export const UploadContentLiveStream = () => {
  const { eventId } = useParams();
  const navigate = useNavigate();

  return (
    <UploadContentLayout goBack={() => navigate(`/events/${eventId}/upload-content/requests`)}>
      <EventProvider eventId={Number(eventId)}>
        <LiveStream isMobileView />
      </EventProvider>
    </UploadContentLayout>
  );
};
